import { processingBillingConfigSchema } from "@redotech/redo-return-settings-common/processing-billing-config";
import { returnProcessingLevelSchema } from "@redotech/redo-return-settings-common/return-processing-level";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const ProtectedSettingsAction = {
  bypassApproval: "bypassApproval",
  requestApproval: "requestApproval",
} as const;
export type ProtectedSettingsAction =
  (typeof ProtectedSettingsAction)[keyof typeof ProtectedSettingsAction];

/** Table-backed managed returns settings. Remaining team-document fields use putTeam. */
export const saveManagedReturnsSettings = unaryRpc({
  name: "saveManagedReturnsSettings" as const,
  input: z.object({
    teamId: z.string(),
    settings: z.object({
      redoManagedReturns: z.any().optional(),
      reFulfillment: z.any().optional(),
    }),
    billing: processingBillingConfigSchema.optional(),
    returnProcessingLevel: returnProcessingLevelSchema.optional(),
    protectedSettingsAction: z
      .enum([
        ProtectedSettingsAction.bypassApproval,
        ProtectedSettingsAction.requestApproval,
      ])
      .optional(),
  }),
  output: z.object({ ok: z.literal(true) }),
});
